import React, { useState, useEffect, useRef } from "react";
import "../Css/componentes/chatbot.css";
import preguntas from "../QuestionsBot/preguntas.json";  // Importa el archivo JSON
import f14 from "../Images/Log-bot.png";  // Importa la imagen de perfil

const Chatbot = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [messages, setMessages] = useState([
    { text: "¡Hola! Soy Lumo, tu asistente virtual 😊. ¿En qué puedo ayudarte hoy?", isUser: false, quickReplies: ["Preguntas frecuentes", "Preguntas sobre servicios"] },
  ]);
  const [userInput, setUserInput] = useState("");
  const [preguntasFiltradas, setPreguntasFiltradas] = useState([]); // Estado para guardar las preguntas filtradas
  const messagesEndRef = useRef(null);

  // Desplazar hacia el último mensaje
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Abrir/cerrar el chat
  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  // Función para limpiar y normalizar la pregunta
  const limpiarPregunta = (pregunta) => {
    return pregunta
      .trim() // Eliminar espacios al inicio y final
      .toLowerCase() // Convertir a minúsculas
      .replace(/[¿?]/g, ""); // Eliminar los símbolos ¿ y ?
  };

  // Función para convertir enlaces en texto a HTML
  const convertirEnlaces = (texto) => {
    return texto.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  };

  // Generar respuesta del bot utilizando el archivo preguntas.json
  const generateBotResponse = (message) => {
    const preguntaLimpia = limpiarPregunta(message);

    // Verificar si el usuario escribió un número
    const numeroPregunta = parseInt(preguntaLimpia);
    if (!isNaN(numeroPregunta)) {
      // Si el usuario escribió un número, buscar la pregunta correspondiente
      const preguntaSeleccionada = preguntasFiltradas[numeroPregunta - 1];
      if (preguntaSeleccionada) {
        return preguntaSeleccionada.respuesta;
      } else {
        return "Número de pregunta no válido. Por favor, selecciona un número de la lista.";
      }
    }

    // Ignorar palabras comunes como "hola", "adiós", etc.
    const palabrasComunes = ["hola", "adiós", "gracias", "por favor"];
    if (palabrasComunes.includes(preguntaLimpia)) {
      return "¡Hola! ¿En qué puedo ayudarte hoy? 😊";
    }

    // Buscar la pregunta en el archivo JSON
    const preguntaEncontrada = preguntas.find(p =>
      limpiarPregunta(p.pregunta).includes(preguntaLimpia) ||
      preguntaLimpia.includes(limpiarPregunta(p.pregunta))
    );

    if (preguntaEncontrada) {
      return preguntaEncontrada.respuesta;
    } else {
      // Si no hay coincidencia exacta, buscar coincidencias parciales significativas
      const coincidenciasParciales = preguntas.filter(p =>
        limpiarPregunta(p.pregunta).split(" ").some(palabra =>
          preguntaLimpia.includes(palabra) && palabra.length > 3 // Solo palabras con más de 3 caracteres
        )
      );

      if (coincidenciasParciales.length > 0) {
        // Devolver la primera coincidencia parcial
        return coincidenciasParciales[0].respuesta;
      } else {
        return "Lo siento, ¿Podrías reformular tu pregunta o quizas elegir alguna de las opciones de preguntas?😅.\nTambién contactarnos :\n👉 [Aquí😊](https://wa.me/51935312379). 👈";
      }
    }
  };

  // Enviar mensaje
  const sendMessage = (userInput) => {
    if (userInput.trim()) {
      const newMessage = { text: userInput, isUser: true };
      setMessages([...messages, newMessage]);
      setUserInput("");

      // Simular respuesta del bot
      setTimeout(() => {
        const botResponse = generateBotResponse(userInput);
        setMessages((prevMessages) => [...prevMessages, { text: botResponse, isUser: false, quickReplies: ["Preguntas frecuentes", "Preguntas sobre servicios"] }]);
      }, 1000);
    }
  };

  // Manejar la selección de categoría de preguntas
  const handleCategoriaPreguntas = (categoria) => {
    // Filtrar preguntas según la categoría seleccionada
    const filtradas = preguntas.filter(p => p.categoria === categoria);
    setPreguntasFiltradas(filtradas); // Guardar las preguntas filtradas

    // Formatear la lista de preguntas con viñetas y espacios
    const listaPreguntas = filtradas
      .map((p, index) => `${index + 1}. ${p.pregunta}`)
      .join("\n\n"); // Agregar salto de línea entre preguntas

    // Mostrar la lista de preguntas
    setMessages((prevMessages) => [
      ...prevMessages,
      { 
        text: listaPreguntas,
        isUser: false 
      },
    ]);
  };

  // Manejar la tecla Enter
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      sendMessage(userInput);
    }
  };

  return (
    <div>
      {/* Botón flotante */}
      <div className={`chatbot-toggle ${isChatOpen ? "active" : ""}`} onClick={toggleChat}>
        💬
      </div>

      {/* Contenedor del chat */}
      <div className={`chatbot-container ${isChatOpen ? "active" : ""}`}>
        {/* Cabecera del chat */}
        <div className="chatbot-header">
  <h3>Lumo</h3>
  <button className="chatbot-close-btn" onClick={toggleChat}>✖</button>
</div>

        {/* Área de mensajes */}
        <div className="chatbot-messages">
          {messages.map((message, index) => (
            <div key={index} className={`message ${message.isUser ? "user" : "bot"}`}>
              {!message.isUser && <img src={f14} alt="Perfil" className="chatbot-profile-img" />}
              <div
                className="message-content"
                dangerouslySetInnerHTML={{ __html: convertirEnlaces(message.text) }}
              />
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>

        {/* Botones de respuesta rápida */}
        <div className="quick-replies">
          {["Preguntas frecuentes", "Preguntas sobre servicios"].map((reply, idx) => (
            <button key={idx} onClick={() => handleCategoriaPreguntas(reply)}>{reply}</button>
          ))}
        </div>

        {/* Área de entrada */}
        <div className="chatbot-input">
          <input
            type="text"
            placeholder="Escribe tu mensaje..."
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button onClick={() => { sendMessage(userInput); setUserInput(""); }}>Enviar</button>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
